import React from 'react';
import SimplizeLogo from '../../components/SimplizeLogo';
import SidebarIcon from '../../components/icons/SidebarIcon';
import { useChatPlatform } from '../context/ChatPlatformContext';
import Tooltip from './Tooltip';
import BetaIcon from '@/components/BetaIcon';

export default function SidebarHeader() {
    const { isMobile, isSidebarOpen, setIsSidebarOpen } = useChatPlatform();

    if (isMobile) {
        return (
            <div className="flex items-center justify-between px-2 py-3 h-[60px]">
                <div className="flex items-center flex-1 ml-2 gap-[8px]">
                    <SimplizeLogo className="h-6 w-auto" />
                    <BetaIcon />
                </div>
                <button
                    onClick={() => setIsSidebarOpen(false)}
                    className="p-2 text-gray-500 hover:text-black hover:bg-app-hover rounded-md"
                >
                    <SidebarIcon />
                </button>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-between px-2 py-3 h-[60px]">
            {isSidebarOpen ? (
                <>
                    <div className="flex items-center flex-1 ml-2 gap-[8px]">
                        <SimplizeLogo className="h-6 w-auto" />
                        <BetaIcon />
                    </div>
                    <button
                        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                        className="p-2 text-gray-500 hover:text-black hover:bg-app-hover rounded-md"
                    >
                        <SidebarIcon />
                    </button>
                </>
            ) : (
                <div className="flex items-center justify-center w-full">
                    <Tooltip content="Mở thanh bên">
                        <button
                            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                            className="group p-2 text-gray-500 hover:text-black hover:bg-app-hover rounded-md flex-shrink-0"
                        >
                            <SimplizeLogo iconOnly={true} className="h-6 w-auto block group-hover:hidden" />
                            <SidebarIcon open={false} className="w-5 h-5 hidden group-hover:block" />
                        </button>
                    </Tooltip>
                </div>
            )}
        </div>
    );
}
